<template>
  <div class="audio" />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Audio',
  props: {
    id: { type: String, required: true },
  },
  data() {
    return ({
      file: null,
      playTimer: null,
      duration: 2000,
    });
  },
  computed: {
    ...mapGetters({ getSound: 'getSound' }),
    sound() {
      return this.getSound(this.id);
    },
  },
  watch: {
    sound: {
      deep: true,
      handler() {
        const { playing } = this.sound;
        if (playing) {
          this.playHandler();
          clearTimeout(this.playTimer)

          this.playTimer = setTimeout(() => {
            if (this.sound.loop) return;

            if (this.duration >= 11) {
              this.stopHandler();
            }
            this.stop(this.id);
          }, this.duration * 1000);
        } else {
          this.stopHandler();
        }
      },
    },
  },
  created() {
    const { src } = this.sound;
    this.file = new Audio(src);
    this.file.onloadedmetadata = () => {
      this.duration = Math.min(this.file.duration, 10);
    };
    if (src.indexOf('cheers-with-fadeout') > -1) {
      this.file.volume = 0.025;
    } else {
      this.file.volume = 0.2;
    }
    this.file.setAttribute('loop', this.sound.loop);
  },
  methods: {
    ...mapMutations({ stop: 'stop' }),
    playHandler() {
      this.stopHandler();
      this.file.play().catch((error) => {
        console.log(`ERROR: ${error}`);
      });
    },
    stopHandler() {
      this.file.pause();
      this.file.currentTime = 0;
    },
  },
};
</script>
